import { render } from "./ProdutoView.vue?vue&type=template&id=71750d93&scoped=true"
import script from "./ProdutoView.vue?vue&type=script&lang=js"
export * from "./ProdutoView.vue?vue&type=script&lang=js"

import "./ProdutoView.vue?vue&type=style&index=0&id=71750d93&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71750d93"]])

export default __exports__